import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import CloseButton from '../ui/CloseButton.tsx';
import PaperComponent from '../PaperComponent';
import SearchFriends from './SearchFriends.tsx';
import SmallLoader from '../ui/SmallLoader.tsx';

import { setSearchFriendsDialogOpen } from '../../features/app/dialogsSlice';

import { borderedDialogPaperProps } from '../../theme';

const SearchFriendsDialog: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const open = useSelector((state: any) => state.dialogs.searchFriendsDialogOpen);

  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    dispatch(setSearchFriendsDialogOpen(false));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      PaperComponent={PaperComponent}
      hideBackdrop={false}
      fullWidth
      aria-labelledby="draggable-dialog-title"
      aria-describedby="alert-dialog-description"
      {...borderedDialogPaperProps}
      sx={{ zIndex: 1402 }}
    >
      <DialogTitle textAlign="center" style={{ cursor: 'move' }} id="draggable-dialog-title">
        {t('Search for friends')}
        {loading && <SmallLoader />}
      </DialogTitle>
      <CloseButton onClick={handleClose} />
      <DialogContent sx={{ maxHeight: '50vh' }}>
        <SearchFriends setLoading={setLoading} />
      </DialogContent>
    </Dialog>
  )
};

export default SearchFriendsDialog;